import { get } from 'lodash';

export const getPaywallBanner = (state) => get(state.paywall, 'banner');
